import { Component, Input, OnInit } from "@angular/core";
import { SettlementsService } from "@app/settlements/shared/settlements.service";
import { DriverViewModel } from "@app/shared/models/drivers/DriverViewModel.model";
import { authenticationService } from "@app/login/auth.service";
import { Permissions } from "@app/shared/models/permissions.enum";

interface DriverBatch {
  id: string;
  batchNo: number;
  batchId: string;
  startDate: string;
  endDate: string;
  unitNumber: string;
  driverName: string;
  earnProjected: number;
  fuelAmount: number;
  nonFuel: number;
  reimbursement: number;
  totalDeductions: number;
  totalSettlement: number;
  status: string;
  createdAt: string;
}

@Component({
  selector: "app-driver-settlements",
  templateUrl: "./driver-settlements.component.html",
  styleUrls: ["./driver-settlements.component.css"],
})
export class DriverSettlementsComponent implements OnInit {
  @Input() driver: DriverViewModel;
  @Input() isEditMode: boolean;

  batches: DriverBatch[] = [];
  loading: boolean = false;
  canViewSettlementsLoads: boolean = false;

  constructor(
    private settlementsService: SettlementsService,
    private authService: authenticationService
  ) {}

  ngOnInit() {
    this.canViewSettlementsLoads = this.authService.hasPermission(Permissions.SettlementsRead);
    this.loadBatches();
  }

  loadBatches() {
    if (!this.driver || !this.driver.id) return;

    this.loading = true;
    this.settlementsService.getBatchListByDriverId(this.driver.id as any).subscribe({
      next: (batches: any[]) => {
        this.batches = batches;
        this.loading = false;
      },
      error: (err) => {
        console.error("Error loading driver batches:", err);
        this.loading = false;
      },
    });
  }
}
